import { Component, OnInit, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './services/auth.service';
import { AppUpdateService } from './services/app-update.service';
import { ButtonModule } from 'primeng/button';
import { ThermalReceiptComponent } from './shared/thermal-receipt/thermal-receipt.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ButtonModule, ThermalReceiptComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  protected readonly title = signal('kaparking');
  private authService = inject(AuthService);
  private appUpdateService = inject(AppUpdateService);

  ngOnInit(): void {
    this.authService.rehydrateUser();
    this.authService.refreshCurrentUser();
    this.appUpdateService.init();
  }
}
